import { render, staticRenderFns } from "./AppraisalDetails.vue?vue&type=template&id=588c6ad3&scoped=true"
import script from "./AppraisalDetails.vue?vue&type=script&lang=ts"
export * from "./AppraisalDetails.vue?vue&type=script&lang=ts"
import style0 from "./AppraisalDetails.vue?vue&type=style&index=0&id=588c6ad3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c6ad3",
  null
  
)

export default component.exports